import React, { useState } from 'react';
import '../../styles/Start.css';
import '../../styles/RegCard.css';
import { Button, FormField, Text, TextInput } from '@kui/foundations-react';
import { HorizontalLogo } from '@kui/foundations-react/Logo';
import privacyIconA from '../../assets/privacy/privacyoptions-1.svg';
import privacyIconB from '../../assets/privacy/privacyoptions-2.svg';
import * as ProductFamilies from '../../constants/productFamilies';
import ConfirmationDialog from "../util/ModalPop";
import { renderNVAIEnterCancelMessage,renderNVAIEDGXSparkCancelMessage } from "../../constants/errorCode";
import ConfigManager from "../../config/configManager";
import { POST_USER_REGISTRATION } from "../../constants/apiMethods";

const TECH_ACCESS_TERMS_LINK = 'https://www.nvidia.com/en-us/about-nvidia/terms-of-service/';
const PRIVACY_CHOICES_LINK = 'https://www.nvidia.com/en-us/privacy-center/';
const SIGN_IN_HELP_LINK = 'https://www.nvidia.com/en-us/nvidia-enterprise-account-faq/';

const Start = (props) => {
  // State for storing email input value
  const emailParam = new URLSearchParams(window.location.search);
  const prefilledEmail = emailParam.get([...emailParam.keys()].find(k => k.toUpperCase() === "EMAILID")) || '';
  const [email, setEmail] = useState(prefilledEmail);
  // State for storing whether the form is submitting
  const [isSubmitting, setIsSubmitting] = useState(false);
  // State for storing whether the form is valid
  const [isValid, setIsValid] = useState(false);
  const [touched, setTouched] = useState(false);
  const[firstLoad,setFirstLoad] = useState(true);
  const [cancelEVALMessage, setCancelEVALMessage] = useState(null);
  const [cancelEVALDGXSparkMessage, setCancelEVALDGXSparkMessage] = useState(null);
  const [showEVALPopup, setShowEVALPopup] = useState(true);
  const [showEVALDGXSparkPopup, setShowEVALDGXSparkPopup] = useState(true);

  const config = ConfigManager();
  // Read URL params
  const params = new URLSearchParams(window.location.search);
  const licType = params.get([...params.keys()].find(k => k.toUpperCase() === "LICTYPE"));
  const productFamily = params.get([...params.keys()].find(k => k.toUpperCase() === "PRODUCTFAMILY"));
 

  // SHOW EVAL POPUP BEFORE LOGIN
  const showEnterpriseEvalPopup =
    licType && licType.toUpperCase() === "EVAL" &&
    productFamily && (productFamily.toUpperCase() === "NVAIENTERPRISE");
    const showEnterpriseEvalDGXSPARKPopup =
    licType && licType.toUpperCase() === "EVAL" &&
    productFamily && (productFamily.toUpperCase() === "NVAIE_DGX_SPARK");
  const regexEmailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    

  const emailIsValid = email.trim() !== '' && regexEmailValidation.test(String(email).toLowerCase());
  const emailInvalid = touched && !emailIsValid;

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    // Set form submission flag to true
  
    // Perform form validation
    if (email.trim() !== '' &&  
      regexEmailValidation.test(String(email).toLowerCase())) {
      // Email is not empty, consider form as valid
      setIsSubmitting(true);
      setIsValid(true);
      // Perform any additional actions here, like submitting data to a server
      localStorage.setItem("email", email);
      localStorage.setItem("NewAccountCreated", false);
      
  
      // Warm the API's SFDC account lookup while the user signs in. Fire-and-forget: keepalive lets the
      // request outlive the redirect, and no body/custom headers keeps it a simple request (no CORS preflight).
      try {
        fetch(`${POST_USER_REGISTRATION}/prefetch?emailID=${encodeURIComponent(email.trim())}`, {
          method: 'POST',
          keepalive: true,
        }).catch(() => {});
      } catch (e) {
        // never block sign-in
      }
      fetchData(email); // Pass email as an argument to fetchData
      // window.location.assign("");
    } else {
      // Email is empty, consider form as invalid
      setIsValid(false);
      setFirstLoad(false);
      setIsSubmitting(false); 
    }
  };
  
  const fetchData = async (email) => {
    

    localStorage.setItem("returnUrl", window.location.href);

    generateCodeChallenge().then((code_challenge) => {
    const qParams = new URLSearchParams({
      //redirect_uri: process.env.REACT_APP_BASE_NCA_Redirect_URI,
      redirect_uri: process.env.REACT_APP_BASE_NCA_Redirect_URI,
      scope: "openid profile email",
      client_id: process.env.REACT_APP_BASE_NCA_ClientId,
      response_type: "code",
      nonce: window.crypto.getRandomValues(new Uint8Array(32)),
      state: "returnUrl",
      code_challenge: code_challenge,
      code_challenge_method: "S256",
      login_hint: email,
    });
    try {
    
      const authurl = process.env.REACT_APP_BASE_NCA_AUTH_URL;
      const url = `${authurl}?${qParams}`;
      console.log(url);
     
      localStorage.setItem("authStarted", true);
      window.location.assign(url);
      
    } catch (e) {
      console.error(e);
      localStorage.setItem("IsUserLoggedIn", "false");
    }
    });
  }

  // Handler for updating email input value
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleCancel = () => {
    setShowEVALPopup(false);   // hides popup 
    setCancelEVALMessage(renderNVAIEnterCancelMessage());
  };

  const handleCancelDGXSpark = () => {
    setShowEVALDGXSparkPopup(false);   // hides popup 
    setCancelEVALDGXSparkMessage(renderNVAIEDGXSparkCancelMessage());
  };

  const b64url = (array) => {
    const b64 = btoa(String.fromCharCode.apply(null, array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  };

  const generateCodeChallenge = async () => {
    // Generate a 32-octet random sequence
    const rand = window.crypto.getRandomValues(new Uint8Array(32));

    // The PKCE code verifier is the base64url encoding of the random octets
    const codeVerifier = b64url(rand);
    localStorage.setItem("CV", codeVerifier);

    // Calculate the SHA-256 hash of the code verifier
    const data = new TextEncoder().encode(codeVerifier);
    var sha256Hash = await window.crypto.subtle.digest("SHA-256", data);

    // The PKCE code challenge is the base64url encoding of the hash
    return b64url(new Uint8Array(sha256Hash));
  };

  return (
    <>
      {/* Show cancel message for NVAIE INFO*/}
      {cancelEVALMessage && (
        <div className='submit-content'>
          <h2>{cancelEVALMessage}</h2>
        </div>
      )}
       {cancelEVALDGXSparkMessage && (
        <div className='submit-content'>
          <h2>{cancelEVALDGXSparkMessage}</h2>
        </div>
      )}

      <div className='regPage regPage--narrow'>
        <div className="login-container">
          {/* ----------------------------------------------------------
            SHOW NVAIE EVAL INFO POPUP BEFORE LOGIN
           ----------------------------------------------------------- */}
          {showEnterpriseEvalPopup && showEVALPopup && (
            <ConfirmationDialog
              BoxxProductFamily={ProductFamilies.NvaiEnter}
              PartnerURLVal="NVAIEnterprise"
              productfamily={ProductFamilies.NvaiEnter}
              licensetype="EVAL"
              isrwa03={0}
              isrwa04={1}
              idmlogin={config.IDMLogin}
              link="#"
              linktext=""
              title=""
              handleCancelClickEvent={handleCancel}
            />
          )}
               {showEnterpriseEvalDGXSPARKPopup && showEVALDGXSparkPopup && (
            <ConfirmationDialog
              BoxxProductFamily={ProductFamilies.NvaiEnter}
              PartnerURLVal="NVAIEDGXSpark"
              productfamily={ProductFamilies.NVAIESPARK}
              licensetype="EVAL"
              isrwa03={0}
              isrwa04={1}
              idmlogin={config.IDMLogin}
              link="#"
              linktext=""
              title=""
              handleCancelClickEvent={handleCancelDGXSpark}
            />
          )}
          {!cancelEVALMessage && !cancelEVALDGXSparkMessage && (
            <form className="regCard regCard--signin" onSubmit={handleSubmit} noValidate>
              <div className="regHeaderLogo">
                <HorizontalLogo role="img" aria-label="NVIDIA" />
              </div>
              <Text kind="title/md" asChild>
                <h1 className="regHeaderTitle">Sign In</h1>
              </Text>
              <FormField
                id="email"
                slotLabel="Email Address"
                labelPosition="top"
                required
                status={emailInvalid ? 'error' : undefined}
                slotError={emailInvalid ? 'Please enter a valid email' : undefined}
              >
                <TextInput
                  size="medium"
                  type="email"
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={handleEmailChange}
                  onBlur={() => setTouched(true)}
                  disabled={isSubmitting}
                />
              </FormField>
              <Button
                type="submit"
                color="brand"
                kind="primary"
                disabled={isSubmitting || !emailIsValid}
                style={{ width: '100%' }}
              >
                {isSubmitting ? 'Submitting...' : 'Continue'}
              </Button>
              <div className="regSignInFooter">
                <Text kind="label/regular/md" asChild>
                  <p>
                    By proceeding, you agree to the{' '}
                    <a href={TECH_ACCESS_TERMS_LINK} target="_blank" rel="noopener noreferrer">
                      NVIDIA Technology Access Terms of Use
                    </a>
                  </p>
                </Text>
                <div className="regPrivacyChoices">
                  <span className="regPrivacyIcon" aria-hidden="true">
                    <img className="regPrivacyIconA" src={privacyIconA} alt="" />
                    <img className="regPrivacyIconB" src={privacyIconB} alt="" />
                  </span>
                  <Text kind="label/regular/md" asChild>
                    <a href={PRIVACY_CHOICES_LINK} target="_blank" rel="noopener noreferrer">
                      Your Privacy Choices
                    </a>
                  </Text>
                </div>
                <Text kind="label/regular/md" asChild>
                  <a href={SIGN_IN_HELP_LINK} target="_blank" rel="noopener noreferrer">
                    Sign In help
                  </a>
                </Text>
              </div>
            </form>
          )}

        </div>
      </div>
    </>
  );
};

export default Start;
